module.exports = __webpack_public_path__ + "img/2-certifications-fs_in-person.png";